module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-6.png?0d8ab831";